if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      connectedCallback() {
        this.nextUrl = this.dataset.nextUrl;
        this.loader = this.querySelector('.infinite-scroll__loader');
        this.loading = false;
        this.style.display = 'block';
        this.style.minHeight = '1px';
        this.observer = new IntersectionObserver((entries) => entries[0].isIntersecting && this.loadMore(), {
          rootMargin: '600px 0px',
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadMore() {
        if (this.loading || !this.nextUrl) return;
        this.loading = true;
        if (this.loader) this.loader.hidden = false;

        try {
          const url = new URL(this.nextUrl, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

          const grid = document.getElementById('product-grid');
          const newItems = doc.querySelectorAll('#product-grid > li');
          newItems.forEach((li) => grid.appendChild(document.importNode(li, true)));

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(grid);
          }

          const next = doc.querySelector('infinite-scroll');
          this.nextUrl = next ? next.dataset.nextUrl : '';
        } catch (e) {
          console.error('Infinite scroll failed', e);
          this.nextUrl = '';
        } finally {
          this.loading = false;
          if (this.loader) this.loader.hidden = true;
          if (this.nextUrl) {
            // Re-check in case the sentinel is still in view after appending.
            this.observer.unobserve(this);
            this.observer.observe(this);
          } else {
            this.observer.disconnect();
          }
        }
      }
    }
  );
}
